import { render, staticRenderFns } from "./ClassificarTicketComponent.vue?vue&type=template&id=6dbf02ec"
import script from "./ClassificarTicketComponent.vue?vue&type=script&lang=js"
export * from "./ClassificarTicketComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports